const PaymentTypeMap = {
  SWIFT: "Transfer",
  SEPA: "Instant Payment",
};

export default PaymentTypeMap;
